import React, { useEffect } from 'react';
import styles from '../../styles/cards.module.css'
import { paaas } from '../../json/paaas';

const Paaas = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className='container transparencia-container'>
            <div className='row'>
                <div className='col_12'>
                    <div className='transparencia_title'>
                        <h3 className={ styles.title }>
                            {/*<i className={`icon-book ${styles['ico-title']}`} aria-hidden='true'></i>*/}
                            PAAAS
                        </h3>
                        <hr className='hr-gob'></hr>
                    </div>
                </div>
                {
                    paaas.map((item, index) => (
                        <div key={ index } className='col-md-3 col-sm-6 col-12'>
                            <div className={ styles.container }>
                                <h5 className={ styles.name }>
                                    {item.year}
                                </h5>
                                <hr></hr>
                                <a className={ styles.link } href={ item.url } target='_blank' rel='noopener noreferrer'>
                                    <div className={ styles.item }>
                                        <p className={ styles.textLink }>
                                            {item.nombre}
                                        </p>
                                        <i className={`${ styles.iconLink } ${ item.icon }`} aria-hidden='true'></i>
                                    </div>
                                </a>
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default Paaas